import { X, Plus } from 'lucide-react';
import { useState } from 'react';

interface AddPointModalProps {
  machineName: string;
  onClose: () => void;
  onAddPoint: (pointName: string) => void;
}

export function AddPointModal({ machineName, onClose, onAddPoint }: AddPointModalProps) {
  const [pointName, setPointName] = useState('');

  const handleSubmit = () => {
    if (pointName.trim()) {
      onAddPoint(pointName.trim());
      onClose();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div>
            <h2 className="text-gray-900">Add New Point</h2>
            <p className="text-gray-600 mt-1">Machine: {machineName}</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-all"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>
        
        <div className="p-6">
          <div className="space-y-3">
            <label htmlFor="pointName" className="block text-gray-900">
              Point Name
            </label>
            <input
              type="text"
              id="pointName"
              value={pointName}
              onChange={(e) => setPointName(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Enter point name (e.g., MNDE, MDE, PDE, PNDE)"
              autoFocus
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <p className="text-sm text-gray-500">
              Common point names: MNDE, MDE, PDE, PNDE
            </p>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 hover:bg-gray-100 border border-gray-300 rounded-lg transition-all"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={!pointName.trim()}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Plus className="w-4 h-4" />
            Add Point
          </button>
        </div>
      </div>
    </div>
  );
}